import {
    PR_SUPPLIER,
    PR_SUPPLIER_SUCCESS,
    PR_SUPPLIER_ERROR,
    PR_DELIVERY_ORDER,
    PR_DELIVERY_ORDER_SUCCESS,
    PR_DELIVERY_ORDER_ERROR,
    PR_LIST,
    PR_LIST_SUCCESS,
    PR_LIST_ERROR,
    PR_LIST_SEARCH_CHANGE,
    PR_LIST_PAGE_SET,
    PR_LIST_WITHOUT_PR,
    PR_LIST_WITHOUT_PR_SUCCESS,
    PR_LIST_WITHOUT_PR_ERROR,
    PR_UPLOAD_MODAL_SET,
    PR_UPLOAD_CHANGE_SET,
    PR_UPLOAD,
    PR_UPLOAD_SUCCESS,
    PR_UPLOAD_ERROR,
    PR_UPLOAD_SET,
    PR_UPLOAD_SET_SUCCESS,
    PR_UPLOAD_SET_ERROR,
    PR_UPLOAD_RESET
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    supplier: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    listwithoutpr: {
        loading: false,
        data: []
    },
     upload: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            deliveryorder: '',
            upload: '',
            pending_upload: ''
        },
        value: {
            supplier: '',
            deliveryorder: '',
            upload: '',
            pending_upload: ''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PR_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case PR_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case PR_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PR_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case PR_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case PR_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PR_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case PR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case PR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case PR_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case PR_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case PR_LIST_WITHOUT_PR:
            return {
                ...state,
                loading: true,
                listwithoutpr: {
                    ...state.listwithoutpr
                }
            }
        case PR_LIST_WITHOUT_PR_SUCCESS:
            return {
                ...state,
                loading: false,
                listwithoutpr: {
                    ...state.listwithoutpr,
                    ...action.payload
                }
            }
        case PR_LIST_WITHOUT_PR_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PR_UPLOAD_MODAL_SET:
            return {
                ...state,
                upload: {
                    ...state.upload,
                    modal: action.payload
                }
            }
        case PR_UPLOAD_CHANGE_SET:
            return {
                ...state,
                upload: {
                    ...state.upload,
                    data: {
                        ...state.upload.data,
                        ...action.payload
                    }
                }
            }
        case PR_UPLOAD:
            return {
                ...state,
                upload: {
                    ...state.upload,
                    loading: false
                }
            }
        case PR_UPLOAD_SUCCESS:
            return {
                ...state,
                upload: {
                    ...state.upload,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case PR_UPLOAD_ERROR:
            return {
                ...state,
                upload: {
                    ...state.upload,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case PR_UPLOAD_SET:
            return { ...state };

        case PR_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case PR_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case PR_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };

        default:
            return { ...state };
    }
};